const dialogs = []

export function registerDialog(key) {
  unregisterDialog(key)
  dialogs.push(key)
}

export function unregisterDialog(key) {
  const index = dialogs.indexOf(key)
  if (index !== -1) dialogs.splice(index, 1)
}

export function isTopDialog(key) {
  return dialogs.at(-1) === key
}

export function hasOpenDialogs() {
  return dialogs.length > 0
}
